import React, {Component} from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, AlertSettingsControlPanelKey, setAlertSettings } from "../../redux/actions/controlPanelActions";
import configData from "../../config/config.json";
import { LOADING_STATUES } from "../constants/constants";

const componentName = AlertSettingsControlPanelKey;

const emailAcknowledgementDefault = 'I acknowledge your software will send a verification email to this email address to verify its validity, as well as using this email address should any monitoring activities arise.  Message and data rates from my carrier may apply.';
const phoneAcknowledgementDefault = 'I acknowledge your software will send a verification text to this phone number to verify its validity, as well as using this phone number should any monitoring activities arise.  Message and data rates from my carrier may apply.';

const matchDispatchToProps = (dispatch) => {
  return { 
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName)),
    setAlertSettings: (alertSettings, callback) => dispatch(setAlertSettings(alertSettings, callback))
  }
}
	
class AlertSettings extends Component {

  state = {
    businessAlert: true,
    nameAlert: true,
    parcelIdAlert: true,
    numberOfEmails: 0,
    emailConfirmationsExpireIn: 4,
    emailAcknowledgement: emailAcknowledgementDefault,
    numberOfPhones: 0,
    phoneConfirmationsExpireIn: 4,
    phoneAcknowledgement: phoneAcknowledgementDefault,
    maxValidationAttempts: 3,
    maxVerificationAttempts: 10,
    pidLink: '',
    loadingStatus: '',
    message: '',
    errors: {}
  }

  hideLoading = (message, status, content) => {
    this.setState({
      businessAlert: content.businessAlert,
      nameAlert: content.nameAlert,
      parcelIdAlert: content.parcelIdAlert,
      numberOfEmails: content.numberOfEmails,
      emailConfirmationsExpireIn: content.emailConfirmationsExpireIn,
      emailAcknowledgement: content.emailAcknowledgement,
      numberOfPhones: content.numberOfPhones,
      maxValidationAttempts: content.maxValidationAttempts,
      maxVerificationAttempts: content.maxVerificationAttempts,
      phoneConfirmationsExpireIn: content.phoneConfirmationsExpireIn,
      phoneAcknowledgement: content.phoneAcknowledgement,
      pidLink: content.pidLink,
      loadingStatus: LOADING_STATUES.SUCCESS
    })
  }

  handleSubmit = (event) => {

    event.preventDefault();

    if (this.state.businessAlert !== true && this.state.nameAlert !== true && this.state.parcelIdAlert !== true) {
      const errors = {};
      errors['parcelIdAlert'] = 'Must select at least one alert type.';
      this.setState ({
        errors
      })

      return;
    }

    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
    } else {
      return;
    }

    const { loadingStatus, message, errors, token, ...request } = this.state; // remove UI only fields before submitting
    this.props.setAlertSettings(request, this.hideLoading);
  }


  handleChange = (event) => {
    let value = event.target.value;
    value = value === "true" || value === "false" ? JSON.parse(event.target.value) : value;
    this.setState({
      loadingStatus: "",
      errors: {},
      [event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value)
    })

  }

  componentDidMount() {
    this.props.setSelectedControlPanelType();

    axios.get(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/alertSettings", { withCredentials: true })
    .then(
      (response) => {
        const content = response.data.content;
        this.setState( {
          businessAlert: content.businessAlert,
          nameAlert: content.nameAlert,
          parcelIdAlert: content.parcelIdAlert,
          numberOfEmails: content.numberOfEmails ? content.numberOfEmails : 1,
          emailConfirmationsExpireIn: content.emailConfirmationsExpireIn ? content.emailConfirmationsExpireIn : 4,
          emailAcknowledgement: content.emailAcknowledgement ? content.emailAcknowledgement : emailAcknowledgementDefault,
          numberOfPhones: content.numberOfPhones ? content.numberOfPhones : 1,
          maxValidationAttempts: content.maxValidationAttempts ? content.maxValidationAttempts : 3,
          maxVerificationAttempts: content.maxVerificationAttempts ? content.maxVerificationAttempts : 10,
          phoneConfirmationsExpireIn: content.phoneConfirmationsExpireIn ? content.phoneConfirmationsExpireIn : 4,
          phoneAcknowledgement: content.phoneAcknowledgement ? content.phoneAcknowledgement : phoneAcknowledgementDefault,
          pidLink: content.pidLink ? content.pidLink : '',
          loadingStatus : ""
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  render() {
    const formProps = {
      componentName: componentName,
      pageHeading: "Alert Settings",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      successIndicator: this.state.loadingStatus === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.loadingStatus === LOADING_STATUES.LOADING,
      formGroupRows: [
        {
          formGroups: [{ id: 'businessAlert', label: 'Business Alert', fieldType: 'select', value: this.state.businessAlert, style: {minWidth: 200} }]
        },
        {
          formGroups: [{ id: 'nameAlert', label: 'Person Alert', fieldType: 'select', value: this.state.nameAlert, style: {minWidth: 200} }]
        },
        {
          formGroups: [{ id: 'parcelIdAlert', label: 'Parcel ID Alert', fieldType: 'select', value: this.state.parcelIdAlert, style: {minWidth: 200}, error: this.state.errors['parcelIdAlert']  }]
        },
        {
          heading: 'Email',
          formGroups: [{ id: 'emailConfirmationsExpireIn', label: 'Confirmations expire in (hours)', fieldType: 'number', required: true,  value: this.state.emailConfirmationsExpireIn} ] 
        },
        {
          formGroups: [{ id: 'numberOfEmails', label: 'Number of Emails', fieldType: 'select', options: [{code : 0, description: "0"}, { code: 1, description: "1"}, {code : 2, description: "2"}, {code : 3, description: "3"}, {code : 4, description: "4"}, {code : 5, description: "5"}], value: this.state.numberOfEmails, style: {minWidth: 200} }]
        },
        {
          formGroups: [{ id: 'emailAcknowledgement', label: 'Acknowledgement', fieldType: 'text', value: this.state.emailAcknowledgement, style: {minWidth: 800} }]
        },
        {
          heading: 'Phone',
          formGroups: [{ id: 'phoneConfirmationsExpireIn', label: 'Confirmations expire in (hours)', fieldType: 'number', required: true,  value: this.state.phoneConfirmationsExpireIn} ] 
        },
        {
          formGroups: [{ id: 'numberOfPhones', label: 'Number of Phones', fieldType: 'select', options: [{code : 0, description: "0"}, { code: 1, description: "1"}, {code : 2, description: "2"}, {code : 3, description: "3"}, {code : 4, description: "4"}, {code : 5, description: "5"}], value: this.state.numberOfPhones, style: {minWidth: 200} }]
        },
        {
          formGroups: [{ id: 'phoneAcknowledgement', label: 'Acknowledgement', fieldType: 'text', value: this.state.phoneAcknowledgement, style: {minWidth: 800} }]
        },
        {
          formGroups: [{ id: 'maxValidationAttempts', label: 'Max Validation Attempts', fieldType: 'select', options: [{ code: 1, description: "1"}, {code : 2, description: "2"}, {code : 3, description: "3"}], value: this.state.maxValidationAttempts, style: {minWidth: 200} }]
        },
        {
          formGroups: [{ id: 'maxVerificationAttempts', label: 'Max Verification Attempts', fieldType: 'select', options: [{code : 5, description: "5"}, { code: 6, description: "6"}, {code : 7, description: "7"}, {code : 8, description: "8"}, {code : 9, description: "9"}, {code : 10, description: "10"}], value: this.state.maxVerificationAttempts, style: {minWidth: 200} }]
        },
        {
          heading: 'Miscellaneous',
          formGroups: [{ id: 'pidLink', label: 'PID Link (Optional)', fieldType: 'text', required: false,  value: this.state.pidLink, placeholder:'Ex. https://tmcc.trimingov.com/LandShark/PID.pdf', style: {minWidth: 800}} ] 
        },
      ]
    }

    return <FormTemplate {...formProps} />
  }
}

export default connect(null, matchDispatchToProps)(AlertSettings);